module.exports = __webpack_public_path__ + "img/10.796aff08.jpg";